import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Table,
} from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useSelector } from 'react-redux';
import NoDataFound from '../../constants/NoDataFound';

const Aggrement = (props) => {
  const [search, setSearch] = useState('');
  const [challanTable, setChallanTable] = useState([]);
  const sessionData = useSelector((state) => state.sessionState);
  const location = useLocation();
  const navigate = useNavigate();
  const [partyMasterId, setPartyMasterId] = useState('');
  const [partyMasterName, setPartyMasterName] = useState('');

  let initial = {
    pname: '',
    pcode: null,
    pname_short_code: '',
    agr_code_old: '',
    agr_no_old: '',
    item_status_agr: '',
    item_short_name: null,
    item_short_name: '',
    item_name: '',
    item_group_code: null,
    item_group_name: '',
    mix_item_yes_no: '',
    item_loc: '',
    rent_rate: '',
    broken_chg: '',
    agr_qty: '',
    agr_date: null,
    opening_qty: '',
    rate_on_type: '',
    missing_rate: '',
    notaxrate: null,
    s_no: null,
    rate_of_one_pcs: 'pc',
    weight_of_one_pcs: null,
    session_year: sessionData.session_year,
  };
  const [agreementData, setAgreementData] = useState(initial);
  const [agreementTable, setAgreementTable] = useState([]);
  const [itemTable, setItemTable] = useState([]);
  const [searchKey, setSearchKey] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  // const [selectedOption, setSelectedOption] = useState('');
  const [aggreement, setAggreement] = useState(false);
  const dropdownRef = useRef(null);
  const [editMode, setEditMode] = useState(false);
  const [systemRecords, setsystemRecords] = useState({});

  const filteredItems = challanTable[0]?.items?.filter((item) => {
    const value = search.toLowerCase();

    return (
      item.itemName?.toLowerCase().includes(value) ||
      item.itemShortName?.toLowerCase().includes(value) ||
      String(item.agrQty || '').includes(value) ||
      String(item.rate || '').includes(value) ||
      String(item.netQty || '').includes(value)
    );
  });

  const onHandleBackParty = () => {
    navigate(-1);
  };

  const onChangeHandle = (e) => {
    const { name, value } = e.target;
    setAgreementData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // const handleAddCondition = () => {
  //     // setAgreementTable(prevConditions => [...prevConditions, agreementData]);
  //     setSearchKey("")
  //     setAgreementData(initial)
  // }

  const AddAggrementDetail = async () => {
    if (!agreementData.rent_rate) {
      toast.error('Please enter item rent rate');
      return;
    }

    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.post(
        `api/AgreementDetail/create`,
        agreementData,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setSearchKey('');
        setAgreementData(initial);
        GetAggrementDetail(partyMasterId);
        getChallanData();
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  const UpdateAggrementDetail = async () => {
    if (!agreementData.rent_rate) {
      alert('Please Enter the rate');
      return;
    }

    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.post(
        `api/AgreementDetail/update`,
        agreementData,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setSearchKey('');
        setAgreementData(initial);
        GetAggrementDetail(partyMasterId);
        getChallanData();
        setEditMode(false);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  const GetAggrementDetail = async (partyId) => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/AgreementDetail/aggrementByPartyMasterId?partyMasterId=${partyId}&sessionYear=${sessionData.session_year}`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setAgreementTable(response.aggrementMasterDetailData);
        if (response.aggrementMasterDetailData.length != 0) {
          setAggreement(true);
        }
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };
  // const getItemData = async (page = 1, limit = 100000, search = "") => {
  //     try {
  //         let config = {
  //             headers: {
  //                 'Content-Type': 'application/json', // Important for file upload//s
  //                 'accept': 'application/json'
  //             }
  //         };

  //         const response = await apiService.get(`api/ItemMaster/allitem?pageNo=${page}&limit=${limit}&searchKey=${search}`, config)
  //         if (response.response && response.response.data.errors) {
  //             toast.success(response.response?.data?.errors);
  //         }

  //         if (response.status === true) {
  //             setItemTable(response.itemMasterDetailData)
  //         }
  //         else {
  //             toast.success(response.message);
  //         }
  //     } catch (error) {
  //         console.log(error)
  //         toast.error(`SomeThing went wrong!!`);
  //     }
  // };

  useEffect(() => {
    if (location.state) {
      setPartyMasterId(location.state.partyId);
      setPartyMasterName(location.state.partyName);
      GetAggrementDetail(location.state.partyId);
    }
    getChallanData();
    getItemData(1, 10, '');
    setPartyMasterId(props.partyId);
    setPartyMasterName(props.partyName);
  }, [location.state, sessionData]);

  const getChallanData = async () => {
    // ✅ Validate all required params
    //console.log(sessionData,"sessionData in getChallanData");
    //return;
    const startDate = sessionData?.session_start_date;
    const endDate = sessionData?.session_end_date;

    if (
      // !selectionData?.pcode ||
      // !flag ||
      !startDate ||
      !endDate
    ) {
      // Optional: show message or silently return
      // toast.error("Please select all required filters");
      return;
    }

    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/Bill_Rent_Master/GetPartyNetPositionReport?partyMasterId=${props.partyId}&fromDate=${startDate}&toDate=${endDate}&sessionYear=${sessionData.session_year}`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }
      // console.log(response, "response in getChallanData");
      if (response.status === true) {
        setChallanTable(response.customResp);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`Something went wrong!!`);
    }
  };

  const onHandleBackItem = () => {
    navigate('/party');
  };

  const handleOptionSelect = async (event, value) => {
    if (value === null || value === undefined) {
      setAgreementData(initial);
      return;
    }

    let findData = itemTable.find((data) => data.id == value.id);
    await setAgreementData((prevData) => ({
      ...prevData,
      pname: partyMasterName,
      pcode: partyMasterId,
      party_master_id: partyMasterId,
      item_short_name: findData?.item_short_name,
      item_name: findData?.item_name,
      agr_date: new Date(),
      notaxrate: findData?.tax_per ? findData?.tax_per : null,
      item_group_name: findData?.group,
      weight_of_one_pcs: findData?.price_avg_weight_per_pcs
        ? findData?.price_avg_weight_per_pcs
        : null,
      rate_of_one_pcs: 'pc',
      item_code: findData?.id ? findData?.id : null,
      agr_qty: 0,
      // rent_rate: 0,
      missing_rate: 0,
      broken_chg: 0,
      opening_qty: 0,
      mix_item_yes_no: findData?.mix_item_yes_no,
      rent_rate: findData.price_sell_rate,
      // opening_qty: findData?.price_opening_stock_rate
    }));
  };

  const onHandleDeleteItem = async (id) => {
    const isDeleteConfirmed = window.confirm(
      'Are you sure you want to delete this item?',
    );
    if (isDeleteConfirmed) {
      try {
        let config = {
          headers: {
            'Content-Type': 'application/json', // Important for file upload//s
            accept: 'application/json',
          },
        };

        const response = await apiService.delete(
          `api/AgreementDetail/delete?aggrementId=${id}`,
          config,
        );
        if (response.response && response.response.data.errors) {
          toast.success(response.response?.data?.errors);
        }

        if (response.status === true) {
          toast.success(response.message);
          GetAggrementDetail(partyMasterId);
        } else {
          toast.success(response.message);
        }
      } catch (error) {
        console.log(error);
        toast.error(`SomeThing went wrong!!`);
      }
    } else {
      console.log('Deletion canceled.');
    }
  };

  const onHandleEditItem = async (selectedRow) => {
    //let findArray = agreementTable.find((data) => data.id === id);
    // let findArray = challanTable[0]?.items?.find((data) => data.agrId === id);
    setAgreementData({
      ...agreementData,
      id: selectedRow?.agrId,
      pcode: partyMasterId,
      broken_chg: selectedRow?.damage,
      item_code: selectedRow?.itemId ? selectedRow?.itemId : null,
      rent_rate: selectedRow?.rate,
      missing_rate: selectedRow?.missing,
      item_name: selectedRow?.itemName,
      item_short_name: selectedRow?.itemShortName,
      agr_qty: selectedRow?.agrQty,
      rate_on_type: selectedRow?.type,
      opening_qty: selectedRow?.openingQty,
      session_year: sessionData.session_year,
      // agr_date: selectedRow?.agrDate ? new Date(findArray?.agrDate) : null,
    });
    setEditMode(true);
  };

  // get system records detail
  const getSystemRecords = async () => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/System_Records/GetSystem_RecordsById`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setsystemRecords(response.system_RecordsDataById);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  useEffect(() => {
    getSystemRecords();
  }, [!systemRecords]);

  // ===================== Infinity Scrolling in Item ===================
  // const [itemTable, setItemTable] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const getItemData = async (
    page = 1,
    limit = 20,
    search = '',
    append = false,
  ) => {
    try {
      setLoading(true);

      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/ItemMaster/allitem?pageNo=${page}&limit=${limit}&searchKey=${search}`,
        config,
      );

      if (response.status === true) {
        const newData = response.itemMasterDetailData || [];

        setItemTable((prev) => (append ? [...prev, ...newData] : newData));

        setHasMore(newData.length === limit); // if data < limit → no more pages
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.error(error);
      toast.error('Something went wrong!');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (event, value) => {
    setSearchText(value);
    setPage(1);
    getItemData(1, 20, value, false); // Fresh search
  };

  const handleScroll = (event) => {
    const listboxNode = event.currentTarget;

    if (
      listboxNode.scrollTop + listboxNode.clientHeight >=
        listboxNode.scrollHeight - 5 &&
      hasMore &&
      !loading
    ) {
      const nextPage = page + 1;
      setPage(nextPage);
      getItemData(nextPage, 20, searchText, true); // Append mode
    }
  };

  return (
    <>
      <div className='d-flex justify-content-end mb-3'>
        <button
          className='btn btn-sm btn-warning d-flex align-items-center px-3 py-2'
          onClick={onHandleBackItem}
        >
          <i className='bi bi-arrow-left'></i>
          Back
        </button>
      </div>

      <div className='card mb-3 shadow-sm border-0 rounded-lg overflow-hidden'>
        {/* PARTY HEADER */}
        <div
          className='card-header border-0 py-3'
          style={{
            background: 'linear-gradient(135deg, #1a237e 0%, #283593 100%)',
            position: 'sticky',
            top: 0,
            zIndex: 10,
          }}
        >
          <button
            className='btn btn-block w-100 d-flex justify-content-between align-items-center p-0 border-0'
            data-toggle='collapse'
            style={{ fontWeight: 600, background: 'transparent' }}
          >
            <span className='text-white d-flex align-items-center'>
              <span
                className='mr-2 d-flex align-items-center justify-content-center rounded-circle'
                style={{
                  width: 32,
                  height: 32,
                  background: 'rgba(255,255,255,0.15)',
                }}
              >
                <i className='bi bi-person-fill' style={{ fontSize: 14 }}></i>
              </span>
              <span style={{ opacity: 0.8, fontWeight: 400 }}>
                Party:&nbsp;
              </span>
              <strong>{challanTable[0]?.partyName}</strong>
            </span>

            <span
              className='badge px-3 py-2 text-white'
              style={{
                background: 'rgba(255,255,255,0.15)',
                borderRadius: 20,
                fontWeight: 500,
                fontSize: 13,
                letterSpacing: 0.3,
              }}
            >
              <i className='bi bi-box-seam mr-1'></i>
              Opening Qty:&nbsp;<strong>{challanTable[0]?.partyNetQty}</strong>
            </span>
          </button>
        </div>
      </div>

      <div
        className='card border-0 shadow-sm rounded-lg mb-4'
        style={{ overflow: 'hidden' }}
      >
        {/* ── FORM SECTION ── */}
        <div
          className='card-header border-0 d-flex align-items-center justify-content-between py-3 px-4'
          style={{ background: '#f8f9ff', borderBottom: '2px solid #e8eaf6' }}
        >
          <div className='d-flex align-items-center'>
            <span
              className='mr-3 d-flex align-items-center justify-content-center rounded'
              style={{ width: 36, height: 36, background: '#e8eaf6' }}
            >
              <i
                className='bi bi-file-earmark-text'
                style={{ color: '#3949ab', fontSize: 16 }}
              ></i>
            </span>
            <div>
              <h6
                className='mb-0 font-weight-bold'
                style={{ color: '#1a237e', fontSize: 15 }}
              >
                Agreement Item Detail
              </h6>
              <small style={{ color: '#7986cb' }}>{partyMasterName}</small>
            </div>
          </div>
        </div>

        <div
          className='card-body px-4 pt-4 pb-2'
          style={{ background: '#fff', borderBottom: '1px solid #e8eaf6' }}
        >
          <div className='row'>
            <div className='col-md-8'>
              <div className='form-group mb-3'>
                <label
                  htmlFor='item_name'
                  className='font-weight-600 mb-1'
                  style={{ fontSize: 13, color: '#455a64' }}
                >
                  Item Full Name
                </label>
                <Autocomplete
                  size='small'
                  id='item_name'
                  name='item_name'
                  options={itemTable.map((option) => ({
                    id: option.id,
                    label: option.item_name,
                  }))}
                  renderInput={(params) => (
                    <TextField {...params} label='Item Name' />
                  )}
                  value={agreementData.item_name || ''}
                  onChange={handleOptionSelect}
                  onInputChange={handleInputChange}
                  loading={loading}
                  ListboxProps={{
                    onScroll: handleScroll,
                    style: { maxHeight: 250, overflow: 'auto' },
                  }}
                />
              </div>
            </div>
            <div className='col-md-4'>
              <div className='form-group mb-3'>
                <label
                  htmlFor='item_short_name'
                  className='font-weight-600 mb-1'
                  style={{ fontSize: 13, color: '#455a64' }}
                >
                  CODE
                </label>
                <input
                  className='form-control'
                  id='item_short_name'
                  name='item_short_name'
                  value={agreementData.item_short_name}
                  onChange={onChangeHandle}
                  type='text'
                  style={{
                    borderRadius: 8,
                    borderColor: '#c5cae9',
                    fontSize: 14,
                  }}
                  readOnly
                />
              </div>
            </div>
          </div>

          {/* Conditional Fields Row */}
          <div className='row'>
            {systemRecords.pc_rmt_pp_yn === 'yes' && (
              <div className='col-sm-2'>
                <div className='form-group mb-3'>
                  <label
                    style={{ fontSize: 13, color: '#455a64', fontWeight: 600 }}
                  >
                    Pc/Rmt/Pp
                  </label>
                  <select
                    className='form-control custom-select'
                    id='rate_of_one_pcs'
                    name='rate_of_one_pcs'
                    value={agreementData.rate_of_one_pcs}
                    onChange={onChangeHandle}
                    style={{
                      borderRadius: 8,
                      borderColor: '#c5cae9',
                      fontSize: 14,
                    }}
                  >
                    <option value=''>Select</option>
                    <option value='pc'>PC</option>
                    <option value='rmt'>RMT</option>
                    <option value='pp'>PP</option>
                  </select>
                </div>
              </div>
            )}
            {systemRecords.agr_qty_yn === 'yes' && (
              <div className='col-sm-2'>
                <div className='form-group mb-3'>
                  <label
                    style={{ fontSize: 13, color: '#455a64', fontWeight: 600 }}
                  >
                    Agr Qty.
                  </label>
                  <input
                    className='form-control'
                    id='agr_qty'
                    name='agr_qty'
                    value={agreementData.agr_qty}
                    onChange={onChangeHandle}
                    type='tel'
                    style={{
                      borderRadius: 8,
                      borderColor: '#c5cae9',
                      fontSize: 14,
                    }}
                  />
                </div>
              </div>
            )}
            {systemRecords.rent_rate_yn === 'yes' && (
              <div className='col-sm-2'>
                <div className='form-group mb-3'>
                  <label
                    style={{ fontSize: 13, color: '#455a64', fontWeight: 600 }}
                  >
                    Rent Rate
                  </label>
                  <input
                    className='form-control'
                    id='rent_rate'
                    name='rent_rate'
                    value={agreementData.rent_rate}
                    onChange={onChangeHandle}
                    type='text'
                    style={{
                      borderRadius: 8,
                      borderColor: '#c5cae9',
                      fontSize: 14,
                    }}
                  />
                </div>
              </div>
            )}
            {systemRecords.missing_yn === 'yes' && (
              <div className='col-sm-2'>
                <div className='form-group mb-3'>
                  <label
                    style={{ fontSize: 13, color: '#455a64', fontWeight: 600 }}
                  >
                    Missing
                  </label>
                  <input
                    className='form-control'
                    id='missing_rate'
                    name='missing_rate'
                    value={agreementData.missing_rate}
                    onChange={onChangeHandle}
                    type='text'
                    style={{
                      borderRadius: 8,
                      borderColor: '#c5cae9',
                      fontSize: 14,
                    }}
                  />
                </div>
              </div>
            )}
            {systemRecords.damage_yn === 'yes' && (
              <div className='col-sm-2'>
                <div className='form-group mb-3'>
                  <label
                    style={{ fontSize: 13, color: '#455a64', fontWeight: 600 }}
                  >
                    Damage
                  </label>
                  <input
                    className='form-control'
                    id='broken_chg'
                    name='broken_chg'
                    value={agreementData.broken_chg}
                    onChange={onChangeHandle}
                    type='text'
                    style={{
                      borderRadius: 8,
                      borderColor: '#c5cae9',
                      fontSize: 14,
                    }}
                  />
                </div>
              </div>
            )}
            {systemRecords.opening_yn === 'yes' && (
              <div className='col-sm-2'>
                <div className='form-group mb-3'>
                  <label
                    style={{ fontSize: 13, color: '#455a64', fontWeight: 600 }}
                  >
                    Opening
                  </label>
                  <input
                    className='form-control'
                    id='opening_qty'
                    name='opening_qty'
                    value={agreementData.opening_qty}
                    onChange={onChangeHandle}
                    type='text'
                    style={{
                      borderRadius: 8,
                      borderColor: '#c5cae9',
                      fontSize: 14,
                    }}
                  />
                </div>
              </div>
            )}
          </div>

          {/* Submit Button */}
          <div
            className='px-4 py-3 d-flex float-right justify-content-end'
            style={{ background: '#f8f9ff' }}
          >
            {editMode ? (
              <button
                className='btn px-4 py-2 d-flex align-items-center'
                onClick={UpdateAggrementDetail}
                disabled={!agreementData.item_name}
                style={{
                  background: agreementData.item_name
                    ? 'linear-gradient(135deg, #1a237e, #3949ab)'
                    : '#e0e0e0',
                  color: agreementData.item_name ? '#fff' : '#9e9e9e',
                  borderRadius: 8,
                  border: 'none',
                  fontWeight: 600,
                  fontSize: 14,
                  gap: 8,
                  boxShadow: agreementData.item_name
                    ? '0 4px 12px rgba(26,35,126,0.3)'
                    : 'none',
                  transition: 'all 0.2s',
                }}
              >
                <i className='bi bi-pencil-square'></i>
                Update Existing Item In Agreement
              </button>
            ) : (
              <button
                className='btn px-4 py-2 d-flex align-items-center'
                onClick={AddAggrementDetail}
                disabled={!agreementData.item_name}
                style={{
                  background: agreementData.item_name
                    ? 'linear-gradient(135deg, #1b5e20, #388e3c)'
                    : '#e0e0e0',
                  color: agreementData.item_name ? '#fff' : '#9e9e9e',
                  borderRadius: 8,
                  border: 'none',
                  fontWeight: 600,
                  fontSize: 14,
                  gap: 8,
                  boxShadow: agreementData.item_name
                    ? '0 4px 12px rgba(56,142,60,0.3)'
                    : 'none',
                  transition: 'all 0.2s',
                }}
              >
                <i className='bi bi-plus-circle'></i>
                Add New Item In Agreement
              </button>
            )}
          </div>
        </div>

        {/* ── TABLE SECTION ── */}
        <div
          className='card-header border-0 d-flex align-items-center py-3 px-4 mt-2'
          style={{ background: '#f8f9ff', borderTop: '2px solid #e8eaf6' }}
        >
          <span
            className='mr-3 d-flex align-items-center justify-content-center rounded'
            style={{ width: 36, height: 36, background: '#e8eaf6' }}
          >
            <i
              className='bi bi-table'
              style={{ color: '#3949ab', fontSize: 16 }}
            ></i>
          </span>
          <div className='row w-100 align-items-center'>
            <div className='col-sm-6'>
              <h6
                className='mb-0 font-weight-bold'
                style={{ color: '#1a237e', fontSize: 15 }}
              >
                Agreement Item List
              </h6>
              <small style={{ color: '#7986cb' }}>
                {challanTable[0]?.items.length || 0} item
                {challanTable[0]?.items.length !== 1 ? 's' : ''}
              </small>
            </div>

            <div className='col-sm-6 text-right mb-3'>
              <input
                type='text'
                className='form-control'
                placeholder='Search by item name, short name, qty, rate...'
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  borderRadius: 8,
                  border: '1px solid #ccc',
                  padding: '6px 12px',
                }}
              />
            </div>
          </div>
        </div>

        <div className='card-body p-0'>
          <div className='table-responsive table-striped table-hover'>
            <table className='table mb-0' style={{ fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#e8eaf6' }}>
                  {[
                    '#',
                    'Code',
                    'Item Name',
                    'Agr Qty',
                    'Rent Rate',
                    'Type',
                    'Missing',
                    'Damage',
                    'Opening',
                    'Closing',
                    'Actions',
                  ].map((h) => (
                    <th
                      key={h}
                      className='border-0 py-3 px-3 text-white'
                      style={{
                        color: '#3949ab',
                        fontWeight: 700,
                        fontSize: 12,
                        textTransform: 'uppercase',
                        letterSpacing: 0.5,
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredItems?.length > 0 ? (
                  filteredItems?.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        transition: 'background 0.15s',
                        background: index % 2 === 0 ? '#fff' : '#fafbff',
                      }}
                    >
                      <td className='py-3 px-3 align-middle'>
                        <span
                          className='d-inline-flex align-items-center justify-content-center rounded-circle'
                          style={{
                            width: 24,
                            height: 24,
                            background: '#e8eaf6',
                            color: '#3949ab',
                            fontWeight: 700,
                            fontSize: 11,
                          }}
                        >
                          {index + 1}
                        </span>
                      </td>
                      <td className='py-3 px-3 align-middle'>
                        <span
                          className='badge px-2 py-1'
                          style={{
                            background: '#e3f2fd',
                            color: '#1565c0',
                            borderRadius: 6,
                            fontWeight: 600,
                            fontSize: 12,
                          }}
                        >
                          {item.itemShortName}
                        </span>
                      </td>
                      <td
                        className='py-3 px-3 align-middle font-weight-500'
                        style={{ color: '#263238' }}
                      >
                        {item.itemName}
                      </td>
                      <td
                        className='py-3 px-3 align-middle text-center'
                        style={{ color: '#37474f' }}
                      >
                        {item.agrQty}
                      </td>
                      <td
                        className='py-3 px-3 align-middle font-weight-600'
                        style={{ color: '#2e7d32' }}
                      >
                        {typeof item.rate === 'number'
                          ? item.rate?.toFixed(2)
                          : item.rate}
                      </td>
                      <td className='py-3 px-3 align-middle'>
                        {item.type && (
                          <span
                            className='badge px-2 py-1'
                            style={{
                              background: '#f3e5f5',
                              color: '#6a1b9a',
                              borderRadius: 6,
                              fontWeight: 600,
                              fontSize: 11,
                              textTransform: 'uppercase',
                            }}
                          >
                            {item.type}
                          </span>
                        )}
                      </td>
                      <td
                        className='py-3 px-3 align-middle'
                        style={{ color: '#bf360c' }}
                      >
                        {item.missing}
                      </td>
                      <td
                        className='py-3 px-3 align-middle'
                        style={{ color: '#e65100' }}
                      >
                        {item.damage}
                      </td>
                      <td
                        className='py-3 px-3 align-middle'
                        style={{ color: '#37474f' }}
                      >
                        {item.openingQty}
                      </td>
                      <td
                        className='py-3 px-3 align-middle'
                        style={{ color: '#37474f' }}
                      >
                        {item.netQty}
                      </td>
                      <td className='py-3 px-3 align-middle'>
                        <div
                          className='d-flex align-items-center'
                          style={{ gap: 8 }}
                        >
                          <button
                            className='btn btn-sm d-flex align-items-center justify-content-center'
                            title='Edit'
                            onClick={() => onHandleEditItem(item)}
                            style={{
                              width: 30,
                              height: 30,
                              background: '#e3f2fd',
                              color: '#1565c0',
                              border: '1px solid #bbdefb',
                              borderRadius: 6,
                              padding: 0,
                              transition: 'all 0.15s',
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = '#1565c0';
                              e.currentTarget.style.color = '#fff';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = '#e3f2fd';
                              e.currentTarget.style.color = '#1565c0';
                            }}
                          >
                            <i
                              className='bi bi-pencil'
                              style={{ fontSize: 12 }}
                            ></i>
                          </button>
                          <button
                            className='btn btn-sm d-flex align-items-center justify-content-center'
                            title='Delete'
                            onClick={() => onHandleDeleteItem(item.id)}
                            style={{
                              width: 30,
                              height: 30,
                              background: '#fce4ec',
                              color: '#c62828',
                              border: '1px solid #f48fb1',
                              borderRadius: 6,
                              padding: 0,
                              transition: 'all 0.15s',
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = '#c62828';
                              e.currentTarget.style.color = '#fff';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = '#fce4ec';
                              e.currentTarget.style.color = '#c62828';
                            }}
                          >
                            <i
                              className='bi bi-trash'
                              style={{ fontSize: 12 }}
                            ></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <NoDataFound
                    colSpan={11}
                    message={'Add items using the form above'}
                  />
                )}

                {filteredItems?.length > 0 && (
                  <tr className='bg-light'>
                    <th colSpan={8} className='text-right fw-bold'>
                      Total
                    </th>
                    <th className='fw-bold'>
                      {challanTable[0]?.partyOpeningQty}
                    </th>

                    <th className='fw-bold'>{challanTable[0]?.partyNetQty}</th>
                    {/* <th className="text-right fw-bold">{challanTable[0]?.partyTotalWeight}</th>
                                                        <th className="text-right fw-bold">₹ {challanTable[0]?.partyTotalAmount}</th> */}
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Aggrement;
